module.exports = __webpack_public_path__ + "img/temp-blog-03.c86f1e9c.jpg";